import { Sparkles } from "lucide-react";

export function TaglinePill() {
  return (
    <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#f7941d]/20 border border-[#f7941d]/40">
      <Sparkles className="w-3.5 h-3.5 text-[#f7941d]" />
      <span className="text-[13px] font-semibold text-[#f7941d]">
        Job Readiness &amp; Financial Coaching
      </span>
    </div>
  );
}
